import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectLocale } from '@/app/slices/appSlice'
import { selectCurrencyCode } from '@/app/slices/organisationSlice'

export function useCurrencyFormatter(props) {
    const { currencyCode, locale, ...options } = props || {}
    const appCurrency = useSelector(selectCurrencyCode)
    const appLocale = useSelector(selectLocale)
    const defaultCurrency = 'USD'
    const defaultLocale = 'en-US'

    const localeToUse = locale || appLocale || defaultLocale
    const currencyCodeToUse = currencyCode || appCurrency || defaultCurrency

    const formatter = new Intl.NumberFormat(localeToUse, {
        style: 'currency',
        currency: currencyCodeToUse,
        unitDisplay: 'long',
        signDisplay: 'auto',
        useGrouping: true,
        ...options,
    })

    const formatCurrency = useCallback(
        (value) => (value != null && !isNaN(value) ? formatter.format(value) : null),

        [formatter]
    )

    return {
        formatCurrency,
        formatter,
    }
}
